import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";

export default function HeadGeneralList() {
    const { http, user } = AuthUser();
    const [tasks, setTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [editUser, setEditUser] = useState({});
    const [formData1, setFormData1] = useState({
        name: "",
        alpha: "",
    });

    useEffect(() => {
        fetchTaskDetails();
    }, []);

    const fetchTaskDetails = () => {
        setIsLoading(true);
        http
            .get(`/head_generals?company_id=${user.company_id}`)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    };

    const handleChangeModal = (e) => {
        setFormData1({
            ...formData1,
            [e.target.name]: e.target.value,
        });
    };

    const saveEditedCustemer = async (e) => {
        e.preventDefault();
        try {
            if (!editUser) {
                console.error("No user data to edit.");
                return;
            }

            const response = await http.put(`/head_general/${editUser.id}`, formData1);
            toast.success("Head Receipt updated successfully!");
            setShowModal(false);
            fetchTaskDetails();
        } catch (error) {
            console.error("Error updating user", error);
            toast.error("An error occurred while updating the Head Receipt.");
        }
    };

    const deleteTask = async (taskId) => {
        if (window.confirm("Are you sure you want to delete this item?")) {
            await http
                .delete(`/head_general/${taskId}`)
                .then((response) => {
                    toast.success("Head Receipt deleted successfully!");
                    fetchTaskDetails();
                })
                .catch((err) => {
                    console.error("Error deleting task", err);
                    toast.error("Error deleting Head Receipt");
                });
        }
    };

    const openEditModal = async (taskAll) => {
        setShowModal(true);
        setFormData1({
            name: taskAll.name || "",
            alpha: taskAll.alpha || "",
        });
        setEditUser(taskAll);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <Toaster />
            {showModal && (
                <form onSubmit={saveEditedCustemer}>
                    <div className="modal" tabIndex="-1" style={{ display: "block" }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Head Receipt</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={closeModal}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group mt-3">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={formData1.name}
                                            onChange={handleChangeModal}
                                            required
                                        />
                                    </div>
                                    <div className="form-group mt-3">
                                        <label>Alpha</label>
                                        <input
                                            type="text"
                                            name="alpha"
                                            className="form-control"
                                            value={formData1.alpha}
                                            onChange={handleChangeModal}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closeModal}
                                    >
                                        Close
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        Save changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}

            <div className="container mt-1">
                <div className="row">
                    <h1>Head Receipt List</h1>
                    <Link className="add_link text-end mb-3" to="/head_general_add">
                        Add
                    </Link>
                </div>

                <div className="table-responsive">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : (
                        <table className="table table-striped">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-danger">No</th>
                                    <th>Name</th>
                                    <th>Alpha</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tasks.map((taskuser, index) => (
                                    <tr key={taskuser.id}>
                                        <td>{index + 1}</td>
                                        <td>{taskuser.name}</td>
                                        <td>{taskuser.alpha}</td>
                                        <td>
                                            {user.status === 1 && (
                                                <>
                                                    <button
                                                        className="btn btn-link"
                                                        onClick={() => openEditModal(taskuser)}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        className="btn btn-link text-danger"
                                                        onClick={() => deleteTask(taskuser.id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </>
    );
}

